<template>
	<van-popup v-model="show" :position="isMobileFlag?'bottom':'center'" get-container="body" closeable class="bs-popup">
		<div class="bs-popup-head">
			<div class="bs-popup-tit">
				{{$t('会员等级说明')}}
			</div>
		</div>
		<div class="bs-popup-scroll">
			<div class="bs-popup-body " >
					<table class="layui-table layui-align-center">
					  <colgroup>
					    <col width="36%">
					    <col>
					  </colgroup>
					  <thead>
					    <tr>
					      <th>{{$t('等级名称')}}</th>
					      <th>{{$t('累计消费金额')}}</th>
					    </tr> 
					  </thead>
					  <tbody>
					    <tr  v-for="(item, index) in vipDataTips"  :key="index">
					      <td>{{item.level_name}}</td>
					      <td>{{formatNumber(item.fee)}} VND</td>
					    </tr>
					   
					  </tbody>
					</table>
					<div class="vip-desc" style="margin-top: 15px;">
						{{$t('等级说明提示')}}
					</div>
				</div>
		</div>
	</van-popup>
	
</template>
<script>
	import {user_level_list_api} from "@/api/user"
	export default {
		components: {},
		data() {
			return {
				show: false,
				vipDataTips:[]
			};
		},
		methods:{
			async getLevelList(getid) {
				let data = {}
				await user_level_list_api(data).then(res => {
					if (res && res.data.code == 1) {
						this.vipDataTips = res.data.data
					} else if(res && res.data.code == -1){
						this.$helper.rm("tokenInfo");
						this.$helper.rm("userInfo");
						this.$store.commit("$vuexSetLoginState", false);
						this.$store.commit("$vuexUserInfo", null);
						this.goUrl('/login');
					}
				});
			},
		},
		mounted() {
			this.getLevelList()
		}
	}
</script>